import { render } from "./AlleFragenPage.vue?vue&type=template&id=941cf142&scoped=true"
import script from "./AlleFragenPage.vue?vue&type=script&lang=js"
export * from "./AlleFragenPage.vue?vue&type=script&lang=js"

import "./AlleFragenPage.vue?vue&type=style&index=0&id=941cf142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-941cf142"]])

export default __exports__